import { useLocationContext } from '~/contexts/location.context';

export function useGetLocationId() {
  const { locationId, isDea, isKiosk } = useLocationContext();
  return { locationId, isDea, isKiosk };
}
